import { memo, useState, useEffect, useRef } from "react";
import { getNotificationLogsList } from "../../Services/ApiHelper";
import NotificationLogsUI from "./NotificationLogsUI";
import { warn } from "../../Wrapper/toast/toast";
import { changeDateFormatForServer } from "../../Utils/dateUtils";

const NotificationLogs = () => {
  const [loading, setLoading] = useState(false);

  let categories = [
    { label: "Visit", value: "visit" },
    { label: "Visit Completion", value: "visit_completion" },
    { label: "Broadcast", value: "broadcast" },
    { label: "Teleconsult Patient", value: "teleconsult_patient" },
    { label: "Teleconsult Doctor", value: "teleconsult_doctor" },
    { label: "Service Booking", value: "service_booking" },
    { label: "Service Post Done", value: "service_post_done" },
    { label: "Medicine Alert", value: "alert" },
  ];

  const [notifications, setNotifications] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [dates, setDates] = useState({ startDate: null, endDate: null });
  const [selectedOptions, setSelectedOptions] = useState([]);
  const saleDatePickerStartRef = useRef();
  const saleDatePickerEndRef = useRef();

  const datePickerStartRef = useRef();
  const datePickerEndRef = useRef();

  const fetchNotifications = async (page = 1) => {
    const data = {
      page,
      q: searchQuery,
      limit: 10,
      start_date: changeDateFormatForServer(dates.startDate),
      end_date: changeDateFormatForServer(dates.endDate),
      category: selectedOptions,
    };
    setLoading(true);
    try {
      const response = await getNotificationLogsList(data);
      setNotifications(response?.data);
    } catch (error) {
      warn(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, [dates, selectedOptions]);

  const clearFilter = (e) => {
    const dropdownMenu = e.target.closest("#dropdown-basic");
    dropdownMenu.click();
    e.stopPropagation();
    setSelectedOptions([]);
  };

  const handleDropdownChange = (options) => {
    setSelectedOptions(options);
  };

  return (
    <>
      <NotificationLogsUI
        loading={loading}
        list={notifications}
        onPageChange={fetchNotifications}
        selectedOptions={selectedOptions}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        dates={dates}
        setDates={setDates}
        clearFilter={clearFilter}
        handleDropdownChange={handleDropdownChange}
        fetchNotifications={fetchNotifications}
        datePickerStartRef={datePickerStartRef}
        datePickerEndRef={datePickerEndRef}
        saleDatePickerStartRef={saleDatePickerStartRef}
        saleDatePickerEndRef={saleDatePickerEndRef}
        categories={categories}
      />
    </>
  );
};

export default memo(NotificationLogs);
